import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { useRouteParams } from '../hooks/useRouteParams';

interface Upload407LetterParams {
  clientId: string;
  draftId: string;
  file: File;
}

interface Upload407LetterDTO {
  snapId: string;
  fileName: string;
}

const upload407Letter = ({
  clientId,
  draftId,
  file,
}: Upload407LetterParams): Promise<Upload407LetterDTO> => {
  const body = new FormData();

  body.append('clientId', clientId);
  body.append(
    'json',
    JSON.stringify({
      managedAccountId: draftId,
      document: { fileType: null, fileName: file.name, tag: 'AFFILIATED_APPROVAL' },
    }),
  );
  body.append('files', file);

  return authFetch('/Consumer/ManagedAccounts/UploadDocument', {
    method: 'POST',
    body,
  });
};

export const useUpload407LetterMutation = () => {
  const { clientId, draftId } = useRouteParams();

  return useMutation((file: File) => upload407Letter({ clientId, draftId, file }));
};
